import { render, staticRenderFns } from "./pricing-policy.vue?vue&type=template&id=ffbf221a&"
import script from "./pricing-policy.vue?vue&type=script&lang=js&"
export * from "./pricing-policy.vue?vue&type=script&lang=js&"
import style0 from "./pricing-policy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports